import React from 'react';
import View from './view';
import {useTheme} from '../../../shared/theme';
import {useSelector} from 'react-redux';
import {surveysMainListSelector, votesMainListSelector} from '../../../redux/selectors/polls';

export const PollsMainScreen = () => {
  const theme = useTheme();

  const polls = useSelector(surveysMainListSelector());
  const votes = useSelector(votesMainListSelector());

  return <View theme={theme} polls={polls} votes={votes} />;
};
